import smoothHeight from "../modules/smoothHeight.js";
import filterEvents from "./filterEvents.js";
import {filterElement, header} from "../modules/elements.js";
import {getElement} from "../modules/helpers.js";


const filter = () => {

    if (!filterElement) return
    const filterBtn = getElement('[data-target="filter"]');
    const filterTriggers = filterElement.querySelectorAll(".filter__item ");
    const filterContentWrapper = filterElement.querySelector(".filter__content-wrapper");
    const filterParent = getElement('.catalog-page__filter');
    filterParent.parentElement.style.transition = `height 0.7s`
    const advanced = filterElement.querySelector(".filter__advanced");
    const advancedBtn = advanced.querySelector('[data-target="advanced-filter"]');
    const advancedContent = advanced.querySelector(".advanced__content");
    let value = 0;
    let arr = [];
    const filterParentOffsetTop = filterParent.offsetTop;
    const filterContentWrapperHeight = filterParent.clientHeight;
    const filterElementHeight = filterParent.clientHeight;
    filterElement.querySelectorAll(".filter__content").forEach((item) => {
        arr = [item.scrollHeight, ...arr];
    });
    const contentHeight = Math.max(...arr);
    filterTriggers.forEach((item) => {
        const button = item.querySelector(".filter__triger");
        if (screen.width < 1199) {
            const dropdown = item.querySelector('.dropdown')
            if (dropdown) item.style.zIndex = '54';
        }

        button.addEventListener("click", () => {
            toggleFilter();
        });

    });
    if (matchMedia("(max-width: 1199px)").matches) {
        value = getElement('.filter__trigers').clientHeight + advanced.clientHeight;
        if (value < 120) value = 120;
        filterContentWrapper.style.height = `${value}px`
        // filterElement.style.height = `${value +70}px`
    }
    if (matchMedia("(max-width: 1023px)").matches) {
        smoothHeight(".filter__item", ".filter__triger", ".filter__content");
    }
    if (matchMedia("(max-width: 767px)").matches) {
        filterContentWrapper.style.height = `100%`
        filterElement.style.height = `100%`
    }
    smoothHeight(
        ".advanced",
        '[data-target="advanced-filter"]',
        ".advanced__content"
    );
    advancedBtn.addEventListener('click', () => {
        let startFilterContentWrapperHeight = 0;
        if (matchMedia("(min-width: 1199px)").matches) {
            startFilterContentWrapperHeight = contentHeight + advancedContent.scrollHeight;
            if (advanced.dataset.open == 'true') {
                advanced.style.maxHeight = '100%';
                filterContentWrapper.style.maxHeight = `${startFilterContentWrapperHeight + advanced.scrollHeight + 60}px`;
            } else {
                advanced.style.maxHeight = '58px'
                filterContentWrapper.style.maxHeight = `${startFilterContentWrapperHeight}px`;
            }
        }
        if (screen.width > 1023 && screen.width < 1199) {
            if (advanced.dataset.open == 'true') {
                filterContentWrapper.style.height = `${value + 60}px`;
                filterContentWrapper.addEventListener('scroll', (e) => {
                    if (advanced.offsetTop == e.target.scrollTop) {
                        advanced.style.overflowY = 'scroll'
                    } else {
                        advanced.style.overflowY = 'hidden'
                    }
                })
            } else {

                filterContentWrapper.style.height = `${value}px`;
            }
        }

    })


    if (matchMedia("(min-width: 320px)" && "(max-width: 1199px)").matches) {
        filterElement.classList.add('close');
        filterBtn.addEventListener("click", () => {

            filterElement.classList.toggle('close')
            filterElement.classList.toggle("open");
            filterElement.parentElement.classList.toggle("open");
        });

        filterElement.addEventListener("click", (event) => {
            if (event.target === filterElement) {
                // console.log(filterElement.classList)
                if (filterElement.classList.contains('open')) {
                    filterElement.classList.toggle('close')
                    filterElement.classList.toggle("open");
                }
                filterElement.parentElement.classList.toggle("open");
            }
        });
    }
    window.addEventListener('scroll', () => {
        let offTop = getElement('.black-friday') ? filterParentOffsetTop - header.clientHeight + getElement('.black-friday').clientHeight : filterParentOffsetTop - header.clientHeight
        if (offTop <= window.pageYOffset) {
            if (!filterParent.classList.contains('fixed')) filterParent.classList.add('fixed');
            if (filterParent.dataset.fixed == "false") filterParent.dataset.fixed = 'true';
            if (screen.width > 1199) {
                filterParent.parentElement.style.height = filterParent.clientHeight + 'px'
            } else {
                filterParent.parentElement.style.height = filterContentWrapperHeight + 'px'
            }

            // filterParent.parentElement.style.maxHeight = filterParent.clientHeight + 'px'
        } else {
            filterParent.classList.remove('fixed')
            filterParent.dataset.fixed = 'false';
            filterParent.parentElement.style.height = 'auto'
        }
    })
    filterEvents();

    function changeHeight(boolean, el, height) {
        filterElement.querySelectorAll(el).forEach((item) => {
            if (boolean == "true") {
                item.style.maxHeight = `${contentHeight}px`;
            } else {
                item.style.maxHeight = `${height}px`;
            }
        });
    }

    function toggleFilter() {
        if (matchMedia("(min-width: 1199px)").matches) {
            if (filterElement.dataset.open !== "true") {
                filterElement.dataset.open = "true";
                filterContentWrapper.style.maxHeight = `${contentHeight + advanced.scrollHeight + filterContentWrapperHeight}px`;
                // filterElement.style.maxHeight = `${100}%`;
                changeHeight(filterElement.dataset.open, ".filter__content", 0);
                advanced.style.maxHeight = '58px'
                filterElement.classList.add("active");
            } else {
                filterElement.dataset.open = "false";
                if (advanced.dataset.open = "true") {
                    advanced.style.maxHeight = '0'
                    advanced.dataset.open = "false";
                    advancedContent.style.maxHeight = "0";
                    advancedBtn.classList.remove("active");
                }
                changeHeight(filterElement.dataset.open, ".filter__content", 0);
                filterContentWrapper.style.maxHeight = `${filterContentWrapperHeight}px`;
                if (filterElement.dataset.open != 'true' && filterParent.dataset.fixed == 'true') {
                    filterParent.parentElement.style.height = filterContentWrapperHeight + 'px'
                }
                filterElement.classList.remove("active");
            }


        }

    }
};

export default filter;
